import { axios } from '@pukka/auth';
import { MOKA_GOAUTH_SERVICE } from '@pukka/common/constants';

import { BusinessSettingsModel } from '../models';

const BUSINESS_SETTINGS_URL = `${MOKA_GOAUTH_SERVICE}/business-service/v3/businesses/settings`;

async function getSettings() {
  const { data } = await axios.get(BUSINESS_SETTINGS_URL);

  return data;
}

async function updateSettings(newSettings: BusinessSettingsModel.Root) {
  const { data } = await axios.put(BUSINESS_SETTINGS_URL, newSettings);

  return data;
}

export { getSettings, updateSettings, BUSINESS_SETTINGS_URL };
